import { ElementNode } from 'lexical';

export class LayoutContainerNode extends ElementNode {
    __templateColumns: string;

    static getType(): string {
        return 'layout-container';
    }
    static clone(node: LayoutContainerNode): LayoutContainerNode {
        return new LayoutContainerNode(node.__templateColumns, node.__key);
    }

    constructor(templateColumns: string = '1fr', key?: string) {
        super(key);
        this.__templateColumns = templateColumns;
    }

    createDOM(): HTMLElement {
        const dom = document.createElement('div');
        dom.className = 'layout-container';
        dom.style.display = 'grid';
        dom.style.width = '100%';
        dom.style.columnGap = '10px';
        dom.style.gridTemplateColumns = this.__templateColumns;
        return dom;
    }

    updateDOM(): boolean {
        return false;
    }

    static importJSON(serializedNode: any): LayoutContainerNode {
        const { templateColumns } = serializedNode;
        return new LayoutContainerNode(templateColumns);
    }

    exportJSON() {
        return {
            ...super.exportJSON(),
            type: LayoutContainerNode.getType(),
            templateColumns: this.__templateColumns
        };
    }
}
